/* eslint-disable import/no-extraneous-dependencies */
import compose from 'compose-function';
import { withRouter } from './withRouter';
import { withTonConnect } from './withTonConnect';
export const withProviders = compose(withRouter, withTonConnect);
